import { changetheme } from '@/app/store/layout/layout-action'
import { getLayoutColor } from '@/app/store/layout/layout-selector'
import { logout } from '@/app/store/authentication/authentication.actions'
import { Component, EventEmitter, Output, inject } from '@angular/core'
import { RouterModule } from '@angular/router'
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { SimplebarAngularModule } from 'simplebar-angular'
import { TabItems } from './data'
import { AuthenticationService } from '@/app/core/service/auth.service'

const TIPO_LABELS: Record<string, string> = {
  cliente: 'Merchant Account',
  suporte: 'Support Account',
  admin: 'Admin Account',
}

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    NgbDropdownModule,
    SimplebarAngularModule,
    NgbNavModule,
    RouterModule,
  ],
  templateUrl: './topbar.component.html',
  styles: ``,
})
export class TopbarComponent {
  tabItems = TabItems
  store = inject(Store)
  scrollY = 0
  @Output() mobileMenuButtonClicked = new EventEmitter()

  private authenticationService = inject(AuthenticationService)

  constructor() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.handleScroll()
  }

  get currentUserName(): string {
    const user = this.authenticationService.currentUserData
    const fullName = [user?.nome, user?.sobrenome].filter(Boolean).join(' ')
    return fullName || 'My Account'
  }

  get currentUserFirstName(): string {
    return this.authenticationService.currentUserData?.nome || 'there'
  }

  get greeting(): string {
    const hour = new Date().getHours()
    if (hour < 12) return 'Good Morning'
    if (hour < 18) return 'Good Afternoon'
    return 'Good Evening'
  }

  get currentUserTypeLabel(): string {
    const tipo = this.authenticationService.currentUserType
    return (tipo && TIPO_LABELS[tipo]) || ''
  }

  onLogout(): void {
    this.store.dispatch(logout())
  }

  toggleMobileMenu() {
    this.mobileMenuButtonClicked.emit()
  }

  // Change Theme
  changeTheme() {
    const color = document.documentElement.getAttribute('data-bs-theme')
    if (color == 'light') {
      this.store.dispatch(changetheme({ color: 'dark' }))
    } else {
      this.store.dispatch(changetheme({ color: 'light' }))
    }
    this.store.select(getLayoutColor).subscribe((color) => {
      document.documentElement.setAttribute('data-bs-theme', color)
    })
  }
  handleScroll = () => {
    this.scrollY = window.scrollY
  }
}
